import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import("@/views/Home/Home.vue")
  },
  {
    path: '/login',
    name: 'login',
    component: () => import("@/views/Login/Login.vue")
  },
  {
    path: '/user',
    name: 'user',
    component: () => import("@/views/User/User.vue")
  }
]

const router = new VueRouter({
  routes
})

export default router
